import { Component } from "@angular/core";
import {
  FormsModule,
  ReactiveFormsModule,
  FormBuilder,
  FormGroup,
  Validators,
} from "@angular/forms";
import { Router } from "@angular/router";
import { InputTextModule } from "primeng/inputtext";
import { ButtonModule } from "primeng/button";
import { CommonModule } from "@angular/common";
import { AuthService } from "../auth.service";
import { PasswordResetFlowService } from "../password-reset-flow.service";
import { MessageService } from "primeng/api";
import { ToastModule } from "primeng/toast";
import { environment } from "../../../environments/environment";
import { HttpClient, HttpHeaders } from "@angular/common/http";
interface ValidateEmailResponse {
  valid: boolean;
}
@Component({
  selector: "app-forgot",
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    InputTextModule,
    ButtonModule,
    ToastModule,
  ],
  templateUrl: "./forgot.component.html",
  styleUrls: ["./forgot.component.scss"],
  providers: [MessageService],
})
export class ForgotComponent {
  private apiUrlValidateExpirationCode =
    environment.apiUrlMSIdentifyService + "/auth/validate-expiration-code";
  loginForm: FormGroup;
  submitted = false;
  loading = false;

  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private router: Router,
    private messageService: MessageService,
    private http: HttpClient,
    private resetFlow: PasswordResetFlowService
  ) {
    this.loginForm = this.fb.group({
      code: ["", [Validators.required]],
    });
  }

  get f() {
    return this.loginForm.controls;
  }

  //counter
  countdown: number = 30; // Valor inicial del contador
  isCountdownActive: boolean = false;

  ngOnInit() {
    this.startCountdown();
  }

  startCountdown() {
    this.isCountdownActive = true;
    this.countdown = 30; // Reiniciamos el contador
    const interval = setInterval(() => {
      this.countdown--;
      if (this.countdown <= 0) {
        clearInterval(interval);
        this.isCountdownActive = false;
      }
    }, 1000); // Actualiza cada segundo
  }

  resendCode() {
    if (!this.isCountdownActive) {
      this.startCountdown();
      const email = localStorage.getItem("emailVerifyForgotPassword");
      this.http
        .post<ValidateEmailResponse>(
          `${environment.apiUrlMSCommunicationService}/mailer/validate-email`,
          { email, typeUser: "admin" }
        )
        .subscribe({
          next: (res) => {
            if (res.valid) {
              this.messageService.add({
                severity: "success",
                summary: "Código enviado",
                detail: "Se ha enviado un código a tu correo",
              });
              setTimeout(() => {
                this.router.navigate(["/forgot-password"]);
              }, 3000);
            } else {
              this.f["email"].setErrors({
                ...this.f["email"].errors,
                notExists: true,
              });
              this.loading = false;
            }
          },
          error: (err) => {
            this.loading = false;
            this.messageService.add({
              severity: "error",
              summary: "Error",
              detail: err.error?.message || "No se pudo enviar el código",
            });
          },
        });
    }
  }

  verifyCode() {
    this.submitted = true;
    if (this.loginForm.invalid) return;
    this.loading = true;

    const email = localStorage.getItem("emailVerifyForgotPassword");
    const code = this.loginForm.value.code;

    if (!email) {
      this.loading = false;
      this.messageService.add({
        severity: "error",
        summary: "Error",
        detail: "No se encontró el email para verificación.",
      });
      return;
    }

    const body = { email, code };
    const headers = new HttpHeaders({ "Content-Type": "application/json" });

    this.http
      .post<{ valid: boolean }>(this.apiUrlValidateExpirationCode, body, {
        headers,
      })
      .subscribe({
        next: (response) => {
          this.loading = false;
          if (response.valid) {
            // El mismo código autoriza el cambio de contraseña en el paso
            // siguiente (el servidor ya no lo cambia solo con el correo).
            this.resetFlow.setCode(code);
            this.router.navigate(["/change-password"]);
          } else {
            this.messageService.add({
              severity: "error",
              summary: "Código inválido",
              detail: "El código ingresado no es válido o ha expirado.",
            });
          }
        },
        error: (err) => {
          this.loading = false;
          this.messageService.add({
            severity: "error",
            summary: "Error",
            detail:
              "Ocurrió un error al validar el código. Intenta nuevamente.",
          });
        },
      });
  }
  goBack() {
    this.router.navigate(["/email-forgot-password"]);
  }
  requestEndPointValidateCode() {
    const email = localStorage.getItem("emailVerify");
    this.router.navigate(["/change-password"]);
  }
}
